import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StepperService {
  totalSteps: number = 0;
  private stepperSubject = new BehaviorSubject<number>(0);
  stepperState = this.stepperSubject.asObservable();

  constructor() {}

  fnIncreseStepper() {
    const currentValue = this.stepperSubject.value;
    if (currentValue < this.totalSteps) {
      // Prevent exceeding totalSteps
      this.stepperSubject.next(currentValue + 1);
    }
  }

  fnDecreaseStepper() {
    const currentValue = this.stepperSubject.value;
    if (currentValue > 0) {
      this.stepperSubject.next(currentValue - 1);
    }
  }

  fnStepperReset() {
    this.stepperSubject.next(0);
  }
}
